// extracted by mini-css-extract-plugin
module.exports =  {"specTable":"specTable__38Bke"};